<template>
  <!--  弹出框-->
  <el-dialog title="修改任务" :visible.sync="show" :close-on-click-modal="false" @close="DialogClose()">
    <el-form :model="addForm" ref="addForm" label-position="top" :rules="rule">
      <el-form-item label="任务名称" prop="name">
        <el-input size="small" v-model.trim="addForm.name" placeholder="请输入任务名"></el-input>
      </el-form-item>
      <el-form-item label="监控目标" prop="url">
        <el-input placeholder="请输入域名、链接或ip:端口、微信公众号名称、微信小程序ID。" size="small" :rows="3" v-model.trim="addForm.url"></el-input>
      </el-form-item>
      <el-row>
        <el-form-item label="所属分组" prop="grouping_id">
          <el-select v-model="addForm.grouping_id" placeholder="请选择所属分组，可不选">
            <el-option :value="0" label="默认分组"></el-option>
            <el-option v-for="group in groupList" :value="group.id" :label="group.name"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="监控方式" prop="project">
            <el-select v-model="addForm.project" placeholder="请选择监控方式" @change="change_Type($event)">
              <el-option v-for="(item,key) in $store.state.apilist" :label="item.name" :value="item.interface_name" :key="key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="nodeShow">
          <el-form-item label="监控节点" prop="node">
            <el-select v-model="addForm.node" placeholder="请选择监控节点">
              <el-option v-for="(item,key) in nodelist" :key="key" :label="item.name" :value="item.jiedianid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="addForm.project === 'web'">
          <el-form-item label="查询关键词" prop="content">
            <el-input v-model.trim="addForm.content" placeholder="请输入要查询的关键词"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="12">
          <el-form-item label="监控频率选择">
            <el-radio-group v-model="SeeTimesType" size="small" @change="addForm.time=''">
              <el-radio-button :label="false">推荐</el-radio-button>
              <el-radio-button :label="true">自定义</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="监控频率" prop="time">
            <template slot="label">
              <el-tooltip class="item" effect="dark" content="每隔多长时间执行一次" placement="top">
                <span>监控频率 <i class="el-icon-question"></i></span>
              </el-tooltip>
            </template>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="addForm.time" v-if="SeeTimesType">
              <template slot="append">分钟</template>
            </el-input>
            <el-select v-else v-model="addForm.time" placeholder="请选择监控频率">
              <el-option label="30分钟" value="30"></el-option>
              <el-option label="5分钟" value="5"></el-option>
              <el-option label="1分钟" value="1"></el-option>
              <el-option label="1小时" value="60"></el-option>
              <el-option label="2小时" value="120"></el-option>
              <el-option label="6小时" value="360"></el-option>
              <el-option label="12小时" value="720"></el-option>
              <el-option label="24小时" value="1440"></el-option>
              <el-option label="3天" value="4320"></el-option>
              <el-option label="7天" value="10080"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="14">
          <el-form-item>
            <template slot="label">
              <el-tooltip class="item" effect="dark" content="选择被监控目标在何种状态下报警" placement="top">
                <span>告警模式 <i class="el-icon-question"></i></span>
              </el-tooltip>
            </template>
            <el-radio  v-model="addForm.tongzhistate" size="small" label="0" border>正常告警</el-radio>
            <el-radio  v-model="addForm.tongzhistate" size="small" label="1" border>异常告警</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item>
            <template slot="label">
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">
                  若开启本功能，根据您设置的告警模式，被监控目标状态发生变化，<br>
                  通知或回调后自动关闭任务，从而避免多次重复提醒，节省账号检测点。（建议不要关闭此功能）
                </div>
                <span>自动停用 <i class="el-icon-question"></i></span>
              </el-tooltip>
            </template>
            <el-switch
              :active-value="1"
              :inactive-value="0"
              v-model="addForm.switch"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 报警通知模块-->
      <el-divider>报警通知</el-divider>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否开启报警通知">
            <el-switch  v-model="addForm.tongzhiswitch"
              active-value="1"
              inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
<!--          设置监控复查次数，以防止某些接口受网络波动影响而出现误报-->
          <el-form-item v-if="addForm.tongzhiswitch == 1">
            <template slot="label">
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">
                  设置监控复查次数，可以降低某些接口受网络波动影响误报几率。
                </div>
                <span>是否开启报警复查<i class="el-icon-question"></i></span>
              </el-tooltip>
            </template>
            <el-switch v-model="addForm.review_switch" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item v-if="addForm.tongzhiswitch== 1 &&addForm.review_switch == 1" label="复查次数">
            <el-input-number size="small" :min="1" :max="3" v-model="addForm.review_count"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="addForm.tongzhiswitch == 1">
        <el-form-item label="通知渠道">
          <el-radio style="width: 18%;" v-model="addForm.tongzhitype" label="1" @change="changeTz()">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-icon-test"></use>
              </svg>
            </span>
          </el-radio>
          <!-- 微信-->
          <el-radio style="width: 18%;" v-model="addForm.tongzhitype" label="4" @change="changeTz()">
           <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-weixin"></use>
              </svg>
           </span>
          </el-radio>
          <el-radio style="width: 18%;" v-model="addForm.tongzhitype" label="5" @change="changeTz()">
            <span>
              <svg class="icon dingding_icon" aria-hidden="true">
                <use xlink:href="#icon-dingding"></use>
              </svg>
            </span>
          </el-radio>
          <el-radio style="width: 18%;" v-model="addForm.tongzhitype" label="7" @change="changeTz()">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-icon-test1"></use>
              </svg>
            </span>
          </el-radio>
          <el-radio style="width: 18%;" v-model="addForm.tongzhitype" label="2" @change="changeTz()">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-xinxiduanxinsixinduihua"></use>
              </svg>
            </span>
          </el-radio>
          <el-radio style="width: 18%;" v-model="addForm.tongzhitype" label="3" @change="changeTz()">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-dianhuabeifen"></use>
              </svg>
            </span>
          </el-radio>
          <el-radio style="width: 18%;" v-model="addForm.tongzhitype" label="8" @change="changeTz()">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-feishu"></use>
              </svg>
            </span>
          </el-radio>
          <el-radio style="width: 18%;" v-model="addForm.tongzhitype" label="6" @change="changeTz()">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-telegram"></use>
              </svg>
            </span>
          </el-radio>

<!--          <el-radio style="width: 18%;" v-model="addForm.tongzhitype" label="8" @change="changeTz()">-->
<!--            <span>-->
<!--              <svg class="icon" aria-hidden="true">-->
<!--                <use xlink:href="#icon-qq"></use>-->
<!--              </svg>-->
<!--            </span>-->
<!--          </el-radio>-->
        </el-form-item>
        <el-form-item label="通知账户" prop="mail">
          <!--微信通知选择-->
          <el-select v-model="addForm.mail" v-if="addForm.tongzhitype==4 && wx_contactlist.length != 0">
            <el-option v-for="item in wx_contactlist" :key="item.open_id" :label="item.nickname" :value="item.open_id">{{item.nickname}}</el-option>
          </el-select>
          <!--钉钉通知选择-->
          <el-select v-model="addForm.mail" v-if="addForm.tongzhitype==5 && notice_dingtalk.length != 0">
            <el-option v-for="item in notice_dingtalk" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
          </el-select>
          <!--企业微信通知选择-->
          <el-select v-model="addForm.mail" v-if="addForm.tongzhitype==7 && notice_enterprisewechat.length != 0">
            <el-option v-for="item in notice_enterprisewechat" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
          </el-select>
          <!--企业微信通知选择-->
          <el-select v-model="addForm.mail" v-if="addForm.tongzhitype==8 && notice_feishu.length != 0">
            <el-option v-for="item in notice_feishu" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
          </el-select>
          <el-select v-model="addForm.mail" v-if="addForm.tongzhitype==6 && notice_telegram.length != 0">
            <el-option v-for="item in notice_telegram" :key="item.chat_id" :label="item.type=='group' || item.type=='supergroup'?item.name:item.username" :value="item.chat_id">
              <span>{{item.type=='group' || item.type=='supergroup' ? '群聊' : '个人'}}：{{item.type=='group' || item.type=='supergroup' ?item.name:item.username}}</span>
            </el-option>
          </el-select>
          <el-autocomplete
            v-if="addForm.tongzhitype!=4 && addForm.tongzhitype!=5 && addForm.tongzhitype!=6  && addForm.tongzhitype!=7 && addForm.tongzhitype!=8"
            v-model="addForm.mail"
            :fetch-suggestions="querySearch"
            @select="handleSelect($event)"
            ref="autocompleteIput"
            placeholder="请输入通知账户">
            <template slot-scope="{ item }">
              <span v-if="item.email">{{ item.email}}</span>
              <span v-else-if="item.phone">{{ item.phone}}</span>
            </template>
          </el-autocomplete>
          <p v-if="addForm.tongzhitype==4 && wx_contactlist.length==0" style="margin: 0;color: #666666">您当前未绑定通知微信，请前往绑定:<el-link @click.stop="$router.push({path:'/center/noticeAccount',query:{activeName:3}})" type="primary" :underline="false">立即前往</el-link></p>
          <p v-if="addForm.tongzhitype==5 && notice_dingtalk.length==0" style="margin: 0;color: #666666">您当前未设定钉钉通知机器人，请前往设定:<el-link @click.stop="$router.push({path:'/center/noticeAccount',query:{activeName:4}})" type="primary" :underline="false">立即前往</el-link></p>
          <p v-if="addForm.tongzhitype==6 && notice_telegram.length==0" style="margin: 0;color: #666666">您当前未设定电报通知账户，请前往设定:<el-link @click.stop="$router.push({path:'/center/noticeAccount',query:{activeName:5}})" type="primary" :underline="false">立即前往</el-link></p>
          <p v-if="addForm.tongzhitype==7 && notice_enterprisewechat.length==0" style="margin: 0;color: #666666">您当前未设定电报通知账户，请前往设定:<el-link @click.stop="$router.push({path:'/center/noticeAccount',query:{activeName:5}})" type="primary" :underline="false">立即前往</el-link></p>
          <p v-if="addForm.tongzhitype==8 && notice_feishu.length==0" style="margin: 0;color: #666666">您当前未设定飞书通知账户，请前往设定:<el-link @click.stop="$router.push({path:'/center/noticeAccount',query:{activeName:5}})" type="primary" :underline="false">立即前往</el-link></p>
        </el-form-item>
      </div>
      <el-divider>执行时间段</el-divider>
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <template slot="label">
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">
                  若开启，本任务则在设置的时间内执行，若关闭，则一直执行。<br>
                  若任务未开启，则时间段执行不生效。<br>
                  若当前时间大于终止时间，则自动关闭本任务。
                </div>
                <span>执行时间段<i class="el-icon-question"></i></span>
              </el-tooltip>
            </template>
            <el-switch
              :active-value="1"
              :inactive-value="0"
              v-model="addForm.timeswitch"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="addForm.timeswitch">
          <el-form-item label="执行区间" prop="section_time">
            <el-date-picker
              style="width: 100%"
              v-model="addForm.section_time"
              :picker-options="pickerOptions"
              value-format="timestamp"
              format="yyyy-MM-dd HH:mm"
              type="datetimerange"
              :editable="false"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 回调接口模块-->
      <el-divider>回调接口</el-divider>
      <el-form-item label="是否开启回调通知">
        <el-switch v-model="addForm.callbackurlswitch"
                   :active-value="1"
                   :inactive-value="0"
                   active-color="#13ce66"
                   inactive-color="#ff4949">
        </el-switch>
      </el-form-item>
      <div v-if="addForm.callbackurlswitch">
        <el-form-item label="接口地址" prop="callbackurl">
          <el-input placeholder="链接需以http://或https://开头" size="small" v-model.trim="addForm.callbackurl">
            <el-select style="width: 100px" slot="append" v-model="addForm.callbackurl_type" placeholder="请选择">
              <el-option label="GET" :value="0"></el-option>
              <el-option label="POST" :value="1"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="回调变量说明">
          <div class="VarS">
            <p>{url} : 表示被监控目标，返回示例值：google.com</p>
            <p>{type} : 表示检测类型，返回示例值：被墙/污染检测</p>
            <p>{status} : 表示目标状态，返回示例值：200为正常，201为异常</p>
            <p>{reason} : 表示原因或详情，返回示例值：被墙</p>
            <p style="margin-top: 15px">示例: http://<span style="color:red">domain</span>/?url={url}&type={type}&status={status}&reason={reason}</p>
            <p style="color:red;">提示：回调地址必须返回ok</p>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('closeEdit',false,$refs.addForm.resetFields())">取 消</el-button>
      <el-button type="primary" :loading="addloading" @click="onsubmit()">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props:['show',"rowData","father_page","father_pagesize","groupList"],
  data(){
    var validatePass2 = (rule, value, callback) => {
      var emailreg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      if (this.addForm.tongzhitype==1 && !emailreg.test(value)){
        callback(new Error('请输入正确邮箱号!'));
      }else if(this.addForm.tongzhitype==2||this.addForm.tongzhitype==3) {
        var reg = /^1[3|4|5|7|8|9]\d{9}$/
        var reg2 = /^0\d{2,3}\d{7,8}$/
        if(reg2.test(value) || reg.test(value)){
          callback()
        }else {
          callback(new Error('请输入正确的手机或座机号!'));
        }
      }else{
        callback()
      }
    };
    return {
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000;
        }
      },
      nodeShow:this.rowData.node!='自动节点',//是否显示选择节点
      addForm:{
        id:this.rowData.id,
        name:this.rowData.name,//名称
        url:this.rowData.url,
        project:'',//检测方式
        grouping_id:this.rowData.grouping_id,//检测节点
        node:this.rowData.node,//检测节点
        content: this.rowData.content, // 查询关键词
        time:this.rowData.time,//检测频率
        switch:this.rowData.switch,
        review_switch :this.rowData.review_switch,
        review_count :this.rowData.review_count,
        timeswitch:this.rowData.timeswitch,//执行区间开关
        section_time:JSON.parse(this.rowData.section_time),//执行区间
        tongzhiswitch:this.rowData.tongzhiswitch, // 通知开关
        callbackurlswitch:this.rowData.callbackurlswitch, // 回调开关
        tongzhistate:this.rowData.tongzhistate,//告警模式
        tongzhitype:this.rowData.tongzhitype, //通知方式
        callbackurl:this.rowData.callbackurl, // 回调参数
        mail:this.rowData.tongzhitype==5 || this.rowData.tongzhitype==6  || this.rowData.tongzhitype==7 || this.rowData.tongzhitype== 8 ? parseInt(this.rowData.mail) : this.rowData.mail, // 通知账户
        callbackurl_type:this.rowData.callbackurl_type  //回调提交方式
      },
      rule: {
        name:[
          { required: true, message: '任务名不能为空', trigger: 'blur' },
          { min: 1,max: 6, message: '任务名不得超过6个字符', trigger: 'blur' },
        ],
        url:[
          { required: true, message: '请输入监控目标链接', trigger: 'blur' },
        ],
        project:[
          { required: true, message: '请选择监控方式', trigger: 'change' },
        ],
        node:[
          { required: true, message: '请选择监控节点', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请输入要查询的关键词', trigger: 'change' },
        ],
        time:[
          { required: true, message: '请选择监控频率', trigger: 'change' },
        ],
        mail:[
          { required: true, message: '请选择通知账户', trigger: 'change' },
          { validator: validatePass2, trigger: 'blur' },
        ],
        callbackurl:[
          { required: true, message: '请输入回调链接', trigger: 'blur' },
          { pattern: /http[s]{0,1}:\/\/([\w.]+\/?)\S*/, message: '请输入带http://或https://开头的链接', trigger: 'blur' },
        ],
        section_time:[
          { required: true, message: '请选择执行时间段', trigger: 'blur' }
        ],
      },
      contactlist:[],
      nodelist:[],
      wx_contactlist:[],
      notice_dingtalk:[],
      notice_telegram:[],
      notice_enterprisewechat:[],
      notice_feishu:[],
      SeeTimesType:true,
      addloading:false,
    }
  },
  created () {
    this.notice_dingtalk=this.$store.state.notice_dingtalk
    this.wx_contactlist=this.$store.state.notice_wechat
    this.notice_telegram=this.$store.state.notice_telegram
    this.notice_enterprisewechat=this.$store.state.notice_enterprisewechat
    this.notice_feishu=this.$store.state.notice_feishu
    this.$store.state.apilist.forEach(item=>{
      if(item.name == this.rowData.project){
        if(item.interface_name=='qiang'){
          let arr = this.$store.state.nodelist.filter(item=>{
            return item.country=='cn'
          })
          this.nodelist=arr
        }else{
          this.nodelist=this.$store.state.nodelist
        }
        this.addForm.project =item.interface_name
      }
    })
  },
  methods:{
    //输入框输入检测
    splitInput(val){
      var arr = val.split('\n')
      arr = arr.filter(item=>{
        return item.trim() != ''
      })
      this.addForm.url = arr.join('||')
    },
    handleSelect(item){
      if(this.addForm.tongzhitype==1){
        this.addForm.mail = item.email
      }else if(this.addForm.tongzhitype==2 || this.addForm.tongzhitype==3){
        this.addForm.mail = item.phone
      }
      this.$refs.addForm.clearValidate('mail')
    },
    //更改通知方式
    changeTz(){
      let field = this.$refs.addForm.fields
      field.map(i => {
        if(i.prop === 'mail'){  //通过prop属性值相同来判断是哪个输入框，比如：要移除prop为'user'
          i.resetField()
          return false
        }
      })
      if(this.addForm.tongzhitype==4){
        this.wx_contactlist=this.$store.state.notice_wechat
      }else if(this.addForm.tongzhitype==5){
        this.notice_dingtalk=this.$store.state.notice_dingtalk
      }else if(this.addForm.tongzhitype==6){
        this.notice_telegram = this.$store.state.notice_telegram
      }else if(this.addForm.tongzhitype==7){
        this.notice_enterprisewechat = this.$store.state.notice_enterprisewechat
      }
      this.addForm.mail = ''
    },
    //自动填写
    querySearch(queryString, cb){
      this.contactlist=[]
      if(this.addForm.tongzhitype==1){
        this.contactlist = this.$store.state.notice_email
      }else if(this.addForm.tongzhitype==2 || this.addForm.tongzhitype==3){
        this.contactlist = this.$store.state.notice_phone
      }
      cb(this.contactlist)
    },
    DialogClose(){
      this.$refs.addForm.resetFields()
      this.$emit('closeEdit',false)
    },
    //提交
    onsubmit(){
      this.$refs.addForm.validate(async (bool,obj)=>{
        if(bool){
          this.addloading = true
          this.addForm.page = this.father_page
          this.addForm.eachpage = this.father_pagesize
          try {
            const{data}=await this.$http.post('/task/taskedit',this.addForm)
            if(data.status == 'success'){
              this.$emit('editsuccess',{data:data.data,total:data.total,grouping_id:this.addForm.grouping_id})
              this.$message.success('修改成功')
              this.$emit('closeEdit',false)
            }else{
              this.addloading = false
              this.$message.error(data.msg)
            }
          }catch (e){
            this.$message.error('网络异常,请稍后重试')
            this.addloading = false
          }
        }else{
          this.$message.error(obj[Object.keys(obj)[0]][0].message)
        }
      })
    },
    //判断是否显示选择节点
    change_Type(val){
      let index = this.$store.state.apilist.findIndex(item=>item.interface_name == val)
      if(this.$store.state.apilist[index].nodeswitch==1){
        this.nodeShow =true
        this.addForm.node = ''
      }else{
        this.nodeShow=false
        this.addForm.node = ''
      }
      if(val=='qiang'){
        let arr = this.$store.state.nodelist.filter(item=>{
          return item.country=='cn'
        })
        this.nodelist=arr
      }else{
        this.nodelist=this.$store.state.nodelist
      }
    }
  }
}
</script>

<style lang="less" scoped>
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

/deep/ .el-dialog__body::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: transparent;
}

/*定义滚动条轨道 内阴影+圆角*/

/deep/ .el-dialog__body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: transparent;
}

/*定义滑块 内阴影+圆角*/

/deep/ .el-dialog__body::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #000;
}
.Notice_name{
  font-size: 12px;
  color: #666;
  margin-left: 5px;
}
.el-form{
  .el-divider{
    margin: 40px 0 20px;
    /deep/.el-divider__text{
      font-weight: 700;
      color: #666;
    }
  }
}
.el-form-item{
  margin-bottom: 10px;
  /deep/.el-form-item__label{
    line-height: 30px;
    padding: 0;
    color: #617182;
    font-weight: 600;
  }
}
.icon{
  margin: 0;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
}
.dingding_icon{
  width: 1.7em;
  height: 1.7em;
}
.VarS{
  p{
    margin: 10px 0;
    line-height: 1;
    font-size: 13px;
    color: #666;
  }
}
</style>
